<template>
  <section pr-expand :class="{ step3 }">
    <div class="j j2" data-offset="0" v-if="step3"></div>
    <div class="j" data-offset="0"></div>
    <div pr-expand-body class="stick-body" :style="bodyStyle" :id="id">
      <h3 v-html="title"></h3>
      <div class="cover" :style="coverStyle">
        <div class="cover-clip" :style="clipStyle">
          <div class="cover-img" :style="imageStyle">
            <video v-if="video" :src="video" muted autoplay loop playsinline/>
            <h3 data-p="0,0.5" data-y="0,-100" data-a="1,0" v-html="title"></h3>
            <GridBase alpha50>
              <div class="cnt">
                <slot/>
              </div>
            </GridBase>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { applyRatio, getOffsetTop, getScrollBody } from '@/utils';
import responsive from '@/utils/responsive';
import GridBase from '@/views/components/GridBase';

const wrData = {
  sm: 0.7, md: 0.35, lg: 0.35, xl: 0.375, xxl: 0.35,
};

export default {
  name: 'PrExpand',
  components: { GridBase },
  data() {
    return {
      bodyStyle: {},
      coverStyle: {},
      imageStyle: {},
      clipStyle: {},
      stickContainer: null,
      stickBody: null,
      innerList: [],
      fixed: false,
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    video: { type: String },
    img: { type: String },
    id: { default: '' },
    step3: { type: Boolean, default: false}
  },
  computed: {},
  watch: {
    sv: 'render',
  },
  methods: {
    inner(r) {
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight * 0.5;
      if (d < 0 || d > h) {
        if (this.fixed) {
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit('setFix', false);
        }
      } else {
        if (!this.fixed) {
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$store.commit('setFix', true);
        }
      }
      if (d < - window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);

      const t = (this.sect === 'sm' || this.sect === 'md') ? 55 : 64;
      const w = getScrollBody().clientWidth;
      const y = d > h ? h + t : t;
      const wr = wrData[this.sect];
      const ih = h - t;
      let ch;
      let cw;
      let mch = Math.min(w * wr, h * wr);

      if (d < -h * 0.3) {
        cw = w * wr;
        ch = mch;
      } else if (d > 0) {
        cw = w;
        ch = ih;
      } else {
        cw = w + (w * (1 - wr) * d / (h * 0.3));
        ch = ih + ((ih - mch) * d / (h * 0.3));
      }

      const cl = (w - cw) * 0.5;
      const ct = (ih - ch) * 0.5;

      this.bodyStyle = { paddingTop: t + 'px'};
      this.coverStyle = { height: ih + 'px', top: y + 'px' };
      this.clipStyle = { width: cw + 'px', height: ch + 'px', left: `${cl}px`, top: `${ct}px` };
      this.imageStyle = { width: w + 'px', height: ih + 'px', left: `${-cl}px`, top: `${-ct}px` };
      if (this.img) this.imageStyle.backgroundImage = `url(${this.img})`;
    }
  },
  mounted() {
    this.stickContainer = document.querySelector('.stick-container');
    this.stickBody = this.$el.querySelector('.stick-body');
    this.innerList = this.$el.querySelectorAll('[data-p]');
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[pr-expand] { .h(200vh);
  .j { .abs; .t(100vh); }
  &.step3 {
    .j2 { .t(50vh); }
  }
}

[pr-expand-body] { .extra-bold;
  h3 { .calibre; .fs(48); .semi-bold; .tc; .mt(45); color: #fff; }
  .cover { z-index: 1; .abs; .wf; .lt;
    .cover-clip { .abs; overflow: hidden;
      .cover-img { .wf; .abs; color: #fff; .-box; .bg-c; .cover;
        video { .abs; .lt(50%,50%); .min-h(100%); .min-w(100%); transform: translate(-50%,-50%);}
        h3 { color: #fff; .rel; }
        [grid-base], [grid-base-content] { .abs; .lt; .wh(100%); }
        .cnt { .abs; .lb(); .p(40,20);
          h4 { .fs(38, 54, -1.5); .bold; }
          p { .mt(20); .fs(34, 46, -1.5); .medium; .keep-all; }
          h4 + p { .fs(20, 30, -1); }
        }
      }
    }
  }

  .en & { .semi-bold;
    .cover {
      .cover-clip {
        .cover-img {
          .cnt {
            h4 { .fs(44, 46, 0); .medium; }
            p { .fs(38, 40, 0); }
            h4 + p { .fs(22, 28, 0); }
          }
        }
      }
    }
  }
  @media (min-width: @screen-md-min) {
    h3 { .fs(64); }
    .cover {
      .cover-clip {
        .cover-img {
          .cnt { .abs; .lb(); .p(80, 20); .wf; .-box;
            h4 {.mt(0); .ib; .vat; .w(50%); }
            p { .mt(0); .ml(50%); .ib; .w(50%); .p(0,20); .-box; }
          }
        }
      }
    }
  }
  @media (min-width: @screen-lg-min) {
    h3 { .fs(76); .w(50%); .pl(112); .tl; .mt(50vh); .rel; .t(-36); }
    .cover {
      .cover-clip {
        .cover-img {
          .cnt { .abs; .p(50, 40, 50, 25); .-box; .w(50%);
            h4 { .fs(38, 52, -1.5); .block; .wf; }
            p { .mt(40); .ml(0); .fs(18, 28, -1); .block; .wf; .p(0); }
          }
        }
      }
    }
  }
  @media (min-width: @screen-xxl-min) {
    h3 { .fs(120); .w(49%); .mt(50vh); .rel; .t(-60); }
    .cover {
      .cover-clip {
        .cover-img {
          .cnt { .p(100,40);
            h4 { .fs(48, 64, -2); .block; .wf; }
            p { .mt(31); .fs(28, 42, -1.5); .block; .wf; .p(0); }
          }
        }
      }
    }
    .en & { .semi-bold;
      .cover {
        .cover-clip {
          .cover-img {
            .cnt {
              h4 { .fs(52, 58, 0); }
              // p { .mt(60); .fs(32, 36, 0); }
              p { .fs(52, 58, 0); }
            }
          }
        }
      }
    }
  }
}

</style>
